// Senet defter numarası (note_book_no) için tek kanonik normalizasyon.
// "04", "4", " 4 " gibi farklı yazımlar aynı deftere karşılık gelir; kanonik
// değer sayısal defterlerde başındaki sıfırları atılmış metin halidir ("4").
// Bu mantık get_promissory_note_book_filters RPC'sindeki SQL normalizasyonuyla
// birebir aynı olmalıdır (bkz. supabase/migrations/*_normalize_promissory_note_book_no.sql).
export function normalizeBookNo(raw: string | null | undefined): string {
  if (raw === null || raw === undefined) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';
  if (/^[0-9]+$/.test(trimmed)) {
    return String(parseInt(trimmed, 10));
  }
  return trimmed;
}

// Ekranda gösterim için: sayısal defterlerde 2 haneli ("04"), değilse olduğu gibi.
export function displayBookNo(raw: string | null | undefined): string {
  const canonical = normalizeBookNo(raw);
  if (!canonical) return '';
  if (/^[0-9]+$/.test(canonical)) {
    return canonical.padStart(2, '0');
  }
  return canonical;
}

export function bookLabel(raw: string | null | undefined): string {
  const display = displayBookNo(raw);
  return display ? `Defter ${display}` : '';
}
